import React from "react";
import ResourceAdmin from "../../components/admin/ResourceAdmin";
import { adminApi } from "../../lib/api";
import { programs } from "../../mock/mock";

const progOptions = programs.map((p) => ({ value: p.name, label: p.name }));

export default function TemasAdmin() {
  return (
    <ResourceAdmin
      title="Temas"
      subtitle="Contenidos y lecciones de formación de liderazgo."
      resource={adminApi.resource("temas")}
      defaults={{ titulo: "", descripcion: "", programa: "Supera Kids", orden: 1, activo: true }}
      fields={[
        { name: "titulo", label: "Título", type: "text", placeholder: "Ej. Autoconocimiento" },
        { name: "descripcion", label: "Descripción", type: "textarea", placeholder: "Breve descripción del tema" },
        { name: "programa", label: "Programa", type: "select", options: progOptions },
        { name: "orden", label: "Orden", type: "number" },
        { name: "activo", label: "Estado", type: "switch" },
      ]}
      columns={[
        { name: "orden", label: "#" },
        { name: "titulo", label: "Título", render: (i) => <span className="font-bold text-[#0A1C30]">{i.titulo}</span> },
        { name: "programa", label: "Programa" },
        { name: "activo", label: "Estado", render: (i) => (
          <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-bold ${i.activo ? "bg-[#E2F6EB] text-[#22A860]" : "bg-[#EDF0F4] text-[#6B7688]"}`}>
            {i.activo ? "Activo" : "Inactivo"}
          </span>
        ) },
      ]}
    />
  );
}
